import db from './db';

// Might need to tweak this chunk size
const CHUNK_SIZE = 100;

/**
 * Function to process data in chunks.
 *
 * @param { Object } data
 * @param { number } chunkSize
 * @param { string } countryCode
 */
const processInChunks = async ( data, chunkSize, countryCode ) => {
	for ( let i = 0; i < data.length; i += chunkSize ) {
		const chunk = data.slice( i, i + chunkSize );
		const tableName = `${ countryCode }_productInventory`;
		await db.transaction( 'rw', db.table( tableName ), async () => {
			await db.table( tableName ).bulkAdd( chunk );
		} );
	}
};

/**
 * Fetches data from the server based on the country code.
 *
 * @param { string } countryCode - The country code to fetch data for.
 *
 * @return { Promise<Object> } - A promise that resolves to the JSON data fetched.
 */
const fetchData = async countryCode => {
	const response = await fetch( `${ window.location.origin }/wp-json/ac-product-lookup/v1/products?country-code=${ countryCode }` );
	return response.json();
};

/**
 * Updates the database with the fetched JSON data.
 *
 * @param { Object } jsonData    - The JSON data to update in the database.
 * @param { string } countryCode - The country code associated with the data.
 */
const updateDatabase = async ( jsonData, countryCode ) => {
	const newData = jsonData.products;

	// Fetch the lastUpdated value from the database
	const jsonLastUpdated = jsonData.lastUpdated;

	// Update or add the lastUpdated value in the settings table
	await db.table( `${ countryCode }_settings` ).put( { key: 'lastUpdated', value: jsonLastUpdated } );

	// After updating the lastUpdated value in the settings table
	await db.table( `${ countryCode }_headers` ).clear( ); // Clear existing headers
	const columnOrder = AcProductLookupBlock.table[ countryCode ].map( entry => entry.key );
	const sortedKeys = columnOrder.filter( key => Object.keys( jsonData.products[ 0 ] ).includes( key ) );
	await db.table( `${ countryCode }_headers` ).bulkAdd( sortedKeys.map( ( header, index ) => ( { id: index + 1, name: header } ) ) );

	// Update the database with new data from data.json
	await db.table( `${ countryCode }_productInventory` ).clear();
	await processInChunks( newData, CHUNK_SIZE, countryCode );
};

/**
 * Stores new data in the database if it's newer than existing data.
 *
 * @param { string } countryCode
 */
export const storeData = async countryCode => {
	try {
		const jsonData = await fetchData( countryCode );
		await updateDatabase( jsonData, countryCode );
	} catch ( error ) {
		console.error( 'Failed to store data:', error ); // eslint-disable-line no-console
	}
};
